import { render, staticRenderFns } from "./step_1_results_air.vue?vue&type=template&id=12208f58&"
import script from "./step_1_results_air.vue?vue&type=script&lang=js&"
export * from "./step_1_results_air.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports